import { render, staticRenderFns } from "./mapa-contact.vue?vue&type=template&id=34f0e70e&lang=html"
import script from "./mapa-contact.vue?vue&type=script&lang=js"
export * from "./mapa-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports